//#region Helper Imports

import { DataProviderRequest } from "../../data-provider"

//#endregion

//#region Helepr Imports

import { FileComponent, TypeHelper } from "../../helpers"

//#endregion

//#region Model Imports

import { OpFile } from "../../models/core"
import { OpExportData } from "../../models/util"

//#endregion

//#region Utils Imports

import { size } from "underscore"

//#endregion

export type ExportDataMethod = (data: OpExportData) => DataProviderRequest<OpFile>

export class DataExporter {

    //#region Members

    private readonly exportData: OpExportData

    //#endregion

    //#region Ctor

    public constructor(private readonly method: ExportDataMethod) {
        this.exportData = new OpExportData()
        this.exportData.headers = []
        this.exportData.data = []
    }

    //#endregion

    //#region Column

    public addColumn(caption: string, idDataTypeFormat: number) {
        caption = caption.replace(TypeHelper.underscore, TypeHelper.emptyString);

        if (idDataTypeFormat != null) {
            this.exportData.headers.push(`${caption}_${idDataTypeFormat}_${size(this.exportData.headers)}`);
        }
        else {
            this.exportData.headers.push(`${caption}_${size(this.exportData.headers)}`);
        }
    }

    //#endregion

    //#region Rows

    public addRow(data: any[]): void {
        this.exportData.data.push(data)
    }

    public addRowData(columnIndex: number, rowIndex: number, data: any): void {
        if (this.exportData.data[rowIndex] == null) {
            this.exportData.data[rowIndex] = []
        }

        if (this.exportData.data[rowIndex][columnIndex] == []) {
            this.exportData.data[rowIndex][columnIndex] = []
        }

        this.exportData.data[rowIndex][columnIndex] = data
    }

    //#endregion

    //#region Export

    public exportAndDownload(): JQueryPromise<void> {
        return this
            .export()
            .then((result: OpFile) => {
                FileComponent.OpenFileSaver(result)
            })
    }

    public export(): DataProviderRequest<OpFile> {
        return this.method(this.exportData)
    }

    //#endregion
}